export default __webpack_public_path__ + "static/media/job_offer3_xl.41d59a43.jpg";